"use client" // Error boundaries must be Client Components
// 错误边界组件
import { Component, type ErrorInfo, type ReactNode } from "react"
import ErrorFallback from "./error-fallback"

interface Props {
	children: ReactNode
	fallback?: ReactNode // Optional fallback UI
}

interface State {
	hasError: boolean
}

class ErrorBoundary extends Component<Props, State> {
	public state: State = {
		hasError: false,
	}

	public static getDerivedStateFromError(_: Error): State {
		// Update state so the next render will show the fallback UI.
		return { hasError: true }
	}

	public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		// You can also log the error to an error reporting service
		console.error("Uncaught error:", error, errorInfo)
	}

	public render() {
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return this.props.fallback || <ErrorFallback />
		}

		return this.props.children
	}
}

export default ErrorBoundary
